import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router";
import { routes } from "./constants/routes";

function App() {
  const router = createBrowserRouter(routes);

  return <RouterProvider router={router} />;
}

export default App;
